import { signOut as amplifySignOut } from 'aws-amplify/auth';

import { AUTH_BASE_URL, AUTH_CLIENT_ID, AUTH_SIGN_OUT_URL } from './constants';

// Fully sign out of the Cognito Hosted UI.
//
// Amplify v6's signOut clears the local tokens but then refuses to redirect to
// Cognito's /logout endpoint: getRedirectUrl rejects our redirectSignOut (the
// marketing site) as a different origin than the app and throws
// InvalidOriginException. We let it clear the tokens, swallow that throw, and
// navigate to /logout ourselves. Hitting /logout is what clears the Hosted-UI
// session cookie; without it the next sign-in silently re-authenticates off the
// cookie and the user never actually logs out (BAM-548).
export async function signOut() {
  try {
    await amplifySignOut();
  } catch (err) {
    // Expected: Amplify throws InvalidOriginException on our cross-origin
    // redirectSignOut, *after* clearing tokens. Log anything unexpected but
    // always continue — reaching /logout (cookie clear) is what logs the user
    // out, so we must not let an Amplify error abort the navigation.
    console.error(
      'Amplify signOut failed; continuing to Hosted UI logout',
      err
    );
  }

  const logoutUrl =
    `${(AUTH_BASE_URL ?? '').replace(/\/$/, '')}/logout` +
    `?client_id=${AUTH_CLIENT_ID}` +
    `&logout_uri=${encodeURIComponent(String(AUTH_SIGN_OUT_URL))}`;
  window.location.assign(logoutUrl);
}
